import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { SubjectProvider } from "./context/SubjectContext";
import { BrowserRouter } from "react-router-dom";
import { VisitRequestProvider } from "./context/VisitRequestContext";
import { DashboardProvider } from "./context/DashboardContext";
import { ConsortiaCenterProvider } from "./context/ConsortiaCenterContext";
import { AuthProvider } from "react-oidc-context";
import { SessionProvider } from "./context/SessionApi";
import { CenterProvider } from "./context/CenterContext";
const onSigninCallbackFunc = () => {
  window.location.href = "/";
};

const oidcConfig = {
  authority: process.env.REACT_APP_IDENTITY_AUTHORITY_URL,
  client_id: process.env.REACT_APP_IDENTITY_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_IDENTITY_REDIRECT_URL,
  scope:
    "openid profile email photoURL roles orgs businessStream uid lastSelectedOrg lastSelectedOrgNCN",
  response_type: "code",
  automaticSilentRenew: true,
  onSigninCallback: onSigninCallbackFunc,
};


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
     <AuthProvider {...oidcConfig}>
      
    <CenterProvider>
      <ConsortiaCenterProvider>
      <SubjectProvider>
        <DashboardProvider>
          <VisitRequestProvider>
            <SessionProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
            </SessionProvider>
          </VisitRequestProvider>
        </DashboardProvider>
      </SubjectProvider>
      </ConsortiaCenterProvider>
    </CenterProvider>
    
     </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
